import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import "./style.scss";
import { useCallback, useEffect, useState } from "react";
import { LineChartCPN } from "../../components/Charts/LineChartCPN";
import Link from "../../components/Link";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { FundState } from "../Fund";
import FeeTabPanel from "../../components/FeeTabPanel";
import { API } from "../../utils/apiEndpoint";
import dayjs, { Dayjs } from "dayjs";
import { Constant, formatMoney } from "../../utils/constant";
import { useNavigate, useParams } from "react-router-dom";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box className="custom-tab">{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function FundDetail() {
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [isError, setIsError] = useState(false);
  const [toDate, setToDate] = useState<Dayjs | null>(null);
  const [value, setValue] = useState(0);
  const [dataChart, setDataChart] = useState<any>([]);
  const [fundDetail, setFundDetail] = useState<any>(null);
  const [selectedPeriod, setSelectedPeriod] = useState(-1);
  const navigate = useNavigate();
  const params = useParams<{ id: string }>();
  const fundId = params?.id;
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // const url = new URL(window.location.href);
  // const id = url.searchParams.get("id");


  const genBodyData = (period: any, from: any, to: any) => {
    const currentYear = dayjs().year();
    return {
      numOfYears: period === -1 || from || to ? null : period, // values: 1, 3, 5, 0 (0: get all), sẽ ưu tiên fromDate nếu fromDate != null
      fromDate:
        period === -1
          ? `01/01/${currentYear}`
          : from
          ? from?.format("DD/MM/YYYY")
          : null,
      toDate: period === -1 ? null : to ? to?.format("DD/MM/YYYY") : null,
    };
  };

  const getFundPricePerYear = useCallback((period: any, from: any, to: any) => {
    if (isError) return;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const defaultParams = {
      fundId
    };

    const params = genBodyData(period, from, to);

    const raw = JSON.stringify({
      ...defaultParams,
      ...params,
    });

    const requestOptions: any = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API.fundPrices, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to getFundPricePerYear");
        }
        return response.json();
      })
      .then((jsonData) => {
        setDataChart(jsonData?.historyValues);
        setFundDetail(jsonData);
      })
      .catch((error) => {
        console.error("Error loading JSON:", error);
      });
  }, []);

  useEffect(() => {
    if (fromDate && toDate) {
      const from = dayjs(fromDate);
      const to = dayjs(toDate);
      if (from > to) {
        alert("From date cannot be after To date");
        setIsError(true);
      } else {
        setIsError(false);
      }
    }
  }, [fromDate, toDate]);

  // useEffect(() => {
  //   if (!fundId) {
  //     // onBackClick();
  //   }
  // }, [fundId]);

  useEffect(() => {
    getFundPricePerYear(selectedPeriod, fromDate, toDate);
    const intervalGetFundPerYear = setInterval(() => {
      getFundPricePerYear(selectedPeriod, fromDate, toDate);
    }, Constant.interval);
    return () => {
      clearInterval(intervalGetFundPerYear);
    };
  }, [selectedPeriod, fromDate, toDate, isError]);

  return (
    <div className="fund-detail">
      <Link
        title="Quay lại danh sách"
        url="#"
        onClick={() => {
          navigate('/');
        }}
        icon={<KeyboardArrowLeftIcon fontSize="small" />}
      />
      <Grid container>
        <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
          <p className="title">{fundDetail?.fundName}</p>
        </Grid>
        <Grid size={{ xl: 4, lg: 6, md: 6, sm: 6, xs: 12 }}>
          <Box sx={{ marginBottom: "24px" }}>
            <p className="date">
              {fundDetail?.values[0]?.date}
            </p>
            <p>
              <span className="value">
                {formatMoney(fundDetail?.values[0]?.buyPrice)}
              </span>
              <span className="currency">VND</span>
            </p>
          </Box>
        </Grid>
        <Grid size={{ xl: 4, lg: 6, md: 6, sm: 6, xs: 12 }}>
          <Box sx={{ marginBottom: "24px" }}>
            <p className="date">
              {fundDetail?.values[1]?.date}
            </p>
            <p>
              <span className="value">
                {formatMoney(fundDetail?.values[1]?.buyPrice)}
              </span>
              <span className="currency">VND</span>
            </p>
          </Box>
        </Grid>
        <Grid size={{ xl: 4, lg: 12, md: 12, sm: 12, xs: 12 }}>
          <Box sx={{ marginBottom: "24px" }}>
            <FundState
              price={fundDetail?.fundChanged}
              percent={fundDetail?.percentageChanged}
            />
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              minHeight: 36,
            }}
          >
            <Tab label="Lịch sử Giá đơn vị Quỹ" disableRipple {...a11yProps(0)} />
            <Tab label="Phí Quản lý Quỹ" disableRipple {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <LineChartCPN
          fundId={fundId || ''}
            dataChart={dataChart}
            onSelectPeriod={(data: any) => {
              setSelectedPeriod(data);
            }}
            onSelectFromDate={(data: any) => {
              setFromDate(data);
            }}
            onSelectToDate={(data: any) => {
              setToDate(data);
            }}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <FeeTabPanel />
        </CustomTabPanel>
      </Box>
    </div>
  );
}
